import { render, staticRenderFns } from "./PendingOldAqs.vue?vue&type=template&id=3c6f1410"
import script from "./PendingOldAqs.vue?vue&type=script&lang=js"
export * from "./PendingOldAqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports